import React, { useContext } from 'react';
import styles from './MenuToggle.module.css';
import { Image } from 'react-bootstrap';
import backIcon from './../../../assets/images/icons/backCircle.svg';
import { RootContext } from '../../../hoc/RootContext/RootContext';

const classNames = require('classnames');
function MenuToggle(props) {

  const { isAdminMenuOpen, setIsAdminMenuOpen } = useContext(RootContext);

  return (
    <div className={classNames(isAdminMenuOpen ? styles.menuExpand : styles.menuClose, 'd-flex align-items-center')} onClick={() => setIsAdminMenuOpen(!isAdminMenuOpen)} >
      <Image src={backIcon} alt='' className={styles.backArrow} onClick={props.MenuIconClick} />
    </div >
  )
}

export default MenuToggle;